import createIcon from '@/lib/create-icon'

const ChessIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M22.8584 21.0277C22.858 22.5618 23.8412 25.0429 25.9421 26.7777C29.0996 29.385 30.6784 30.6887 30.9935 31.17C31.354 31.7208 31.2792 31.559 31.469 32.1965C31.6348 32.7537 31.6348 33.552 31.6348 35.1488V35.3013C31.6348 35.678 31.6348 35.8664 31.6676 36.0452C31.7151 36.3051 31.8134 36.5518 31.9566 36.7699C32.0549 36.9198 32.1829 37.0522 32.439 37.3171C33.7025 38.6244 34.334 39.278 34.4532 39.8205C34.6273 40.6124 34.3053 41.4333 33.6498 41.8688C33.2011 42.1668 32.3129 42.1668 30.5367 42.1668H16.3764C14.5336 42.1668 13.6122 42.1668 13.1534 41.8496C12.523 41.4138 12.2131 40.6172 12.3731 39.8442C12.4895 39.2817 13.1486 38.6074 14.4666 37.2588C14.7337 36.9855 14.8673 36.8488 14.9692 36.693C15.109 36.4793 15.206 36.238 15.2543 35.984C15.2895 35.7987 15.2895 35.6032 15.2895 35.2122V30.1223C15.2895 28.758 15.3273 28.8205 14.3997 27.5584C9.00851 20.2227 11.8317 13.099 17.1817 10.344C17.1817 6.99912 18.9999 5.19985 20.746 4.30343C21.5545 3.88837 21.9587 3.68086 22.4085 3.96358C23.4627 4.62604 23.3979 7.66683 22.8584 9.5835C25.1735 9.5835 27.0587 11.5002 27.0587 13.4168L30.6448 17.0373C31.3051 17.823 31.9581 18.6473 31.4583 19.7434C31.1359 20.4502 30.3659 21.0716 29.8072 21.5895C29.0854 22.2588 27.983 22.2588 27.2611 21.5895C26.6058 20.9821 26.1215 20.4748 25.1735 20.6593C24.4017 20.8096 23.6524 21.0722 22.8584 21.0277ZM22.8584 21.0277C21.7954 20.9683 20.5402 20.4757 19.2071 19.1668'
      stroke='url(#paint0_linear_5304_2380)'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M22.8584 21.0277C22.858 22.5618 23.8412 25.0429 25.9421 26.7777C29.0996 29.385 30.6784 30.6887 30.9935 31.17C31.354 31.7208 31.2792 31.559 31.469 32.1965C31.6348 32.7537 31.6348 33.552 31.6348 35.1488V35.3013C31.6348 35.678 31.6348 35.8664 31.6676 36.0452C31.7151 36.3051 31.8134 36.5518 31.9566 36.7699C32.0549 36.9198 32.1829 37.0522 32.439 37.3171C33.7025 38.6244 34.334 39.278 34.4532 39.8205C34.6273 40.6124 34.3053 41.4333 33.6498 41.8688C33.2011 42.1668 32.3129 42.1668 30.5367 42.1668H16.3764C14.5336 42.1668 13.6122 42.1668 13.1534 41.8496C12.523 41.4138 12.2131 40.6172 12.3731 39.8442C12.4895 39.2817 13.1486 38.6074 14.4666 37.2588C14.7337 36.9855 14.8673 36.8488 14.9692 36.693C15.109 36.4793 15.206 36.238 15.2543 35.984C15.2895 35.7987 15.2895 35.6032 15.2895 35.2122V30.1223C15.2895 28.758 15.3273 28.8205 14.3997 27.5584C9.00851 20.2227 11.8317 13.099 17.1817 10.344C17.1817 6.99912 18.9999 5.19985 20.746 4.30343C21.5545 3.88837 21.9587 3.68086 22.4085 3.96358C23.4627 4.62604 23.3979 7.66683 22.8584 9.5835C25.1735 9.5835 27.0587 11.5002 27.0587 13.4168L30.6448 17.0373C31.3051 17.823 31.9581 18.6473 31.4583 19.7434C31.1359 20.4502 30.3659 21.0716 29.8072 21.5895C29.0854 22.2588 27.983 22.2588 27.2611 21.5895C26.6058 20.9821 26.1215 20.4748 25.1735 20.6593C24.4017 20.8096 23.6524 21.0722 22.8584 21.0277ZM22.8584 21.0277C21.7954 20.9683 20.5402 20.4757 19.2071 19.1668'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M22.8584 21.0277C22.858 22.5618 23.8412 25.0429 25.9421 26.7777C29.0996 29.385 30.6784 30.6887 30.9935 31.17C31.354 31.7208 31.2792 31.559 31.469 32.1965C31.6348 32.7537 31.6348 33.552 31.6348 35.1488V35.3013C31.6348 35.678 31.6348 35.8664 31.6676 36.0452C31.7151 36.3051 31.8134 36.5518 31.9566 36.7699C32.0549 36.9198 32.1829 37.0522 32.439 37.3171C33.7025 38.6244 34.334 39.278 34.4532 39.8205C34.6273 40.6124 34.3053 41.4333 33.6498 41.8688C33.2011 42.1668 32.3129 42.1668 30.5367 42.1668H16.3764C14.5336 42.1668 13.6122 42.1668 13.1534 41.8496C12.523 41.4138 12.2131 40.6172 12.3731 39.8442C12.4895 39.2817 13.1486 38.6074 14.4666 37.2588C14.7337 36.9855 14.8673 36.8488 14.9692 36.693C15.109 36.4793 15.206 36.238 15.2543 35.984C15.2895 35.7987 15.2895 35.6032 15.2895 35.2122V30.1223C15.2895 28.758 15.3273 28.8205 14.3997 27.5584C9.00851 20.2227 11.8317 13.099 17.1817 10.344C17.1817 6.99912 18.9999 5.19985 20.746 4.30343C21.5545 3.88837 21.9587 3.68086 22.4085 3.96358C23.4627 4.62604 23.3979 7.66683 22.8584 9.5835C25.1735 9.5835 27.0587 11.5002 27.0587 13.4168L30.6448 17.0373C31.3051 17.823 31.9581 18.6473 31.4583 19.7434C31.1359 20.4502 30.3659 21.0716 29.8072 21.5895C29.0854 22.2588 27.983 22.2588 27.2611 21.5895C26.6058 20.9821 26.1215 20.4748 25.1735 20.6593C24.4017 20.8096 23.6524 21.0722 22.8584 21.0277ZM22.8584 21.0277C21.7954 20.9683 20.5402 20.4757 19.2071 19.1668'
      stroke='url(#paint1_radial_5304_2380)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M15.3333 36.4165H30.6666'
      stroke='url(#paint2_linear_5304_2380)'
      strokeWidth='2.875'
      strokeLinecap='round'
      fill='none'
    />
    <path
      d='M15.3333 36.4165H30.6666'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      fill='none'
    />
    <path
      d='M15.3333 36.4165H30.6666'
      stroke='url(#paint3_radial_5304_2380)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5304_2380'
        x1='11.5'
        y1='3.8335'
        x2='44.707'
        y2='17.6697'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5304_2380'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23 42.1668) scale(11.5 19.5208)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5304_2380'
        x1='15.3333'
        y1='36.4165'
        x2='15.5604'
        y2='38.8352'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5304_2380'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9999 37.4165) scale(7.66667 0.509237)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'ChessIcon'
)

export default ChessIcon
